import config from "./config";

export default {
  styleOverrides: {
    root: {
      borderColor: config.colors.gray.smoke,
    },
  },
};
